interface SidebarSelection {
  projectId?: string;
  sourceType?: string;
  importerIdentifier?: string;
}
interface SidebarFilters {
  sortOrder?: string;
  filters?: Record<string, any>;
}

interface SidebarSettings {
  open: boolean;
  selection: SidebarSelection;
  filters: SidebarFilters;
}

export interface HasBookmarkSidebarSettings {
  sidebarSelection: SidebarSelection;
  sidebarFilters: SidebarFilters;
  sidebarOpen: boolean;
}

/**
 * Extend a model with bookmark sidebar settings.
 */
export function HasBookmarkSidebarSettings(originalClass: {
  new (...args: any[]): { sidebarSettings: SidebarSettings };
}): any {
  return class extends originalClass implements HasBookmarkSidebarSettings {
    get sidebarSelection(): SidebarSelection {
      return this.sidebarSettings.selection || {};
    }

    set sidebarSelection(selection: SidebarSelection) {
      this.sidebarSettings = {
        ...this.sidebarSettings,
        selection,
      };
    }

    get sidebarFilters(): SidebarFilters {
      return this.sidebarSettings.filters || {};
    }

    set sidebarFilters(filters: SidebarFilters) {
      this.sidebarSettings = {
        ...this.sidebarSettings,
        filters,
      };
    }

    get sidebarOpen() {
      return this.sidebarSettings.open;
    }

    set sidebarOpen(open) {
      this.sidebarSettings = {
        ...this.sidebarSettings,
        open,
      };
    }
  };
}
